import http from "../http-common";

class ObservacionService {

    create(data) {
        return http.post("/observacion",data);
    }

    getAll() {
        return http.get("/observacion");
    }

    getbyID(id) {
        return http.get(`/observacion/${id}`);
    }

    updateCC(id, data) {
        return http.put(`/observacion/${id}`,data);
    }

    eliminarCC(id) {
        return http.delete(`/observacion/${id}`);
    }
}

export default new ObservacionService();